export default __webpack_public_path__ + "static/media/PowerPrivilegePosture.187fb9f8.jpeg";